import { render, staticRenderFns } from "./ZoneList.vue?vue&type=template&id=137c6bb6&scoped=true"
import script from "./ZoneList.vue?vue&type=script&lang=js"
export * from "./ZoneList.vue?vue&type=script&lang=js"
import style0 from "./ZoneList.vue?vue&type=style&index=0&id=137c6bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c6bb6",
  null
  
)

export default component.exports